import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['editForm', 'view'];

  static values = {
    id: String,
    deleteUrl: String,
  };

  showEditForm(event) {
    event.preventDefault();
    this.editFormTarget.classList.remove('hidden');
    this.viewTarget.classList.add('hidden');
  }

  hideEditForm() {
    this.editFormTarget.classList.add('hidden');
    this.viewTarget.classList.remove('hidden');
  }

  handleSubmit(event) {
    const [, status] = event.detail;

    if (status === 200) {
      this.hideEditForm();
      // Refresh the row with the updated data
      this.element.reload();
    }
  }

  delete(event) {
    event.preventDefault();
    // eslint-disable-next-line no-alert
    if (window.confirm('Are you sure you want to delete this tag?')) {
      fetch(this.deleteUrlValue, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      }).then(() => {
        this.element.remove();
      });
    }
  }
}
